export { MobileEcommTermsLink } from './terms-link';
